module.exports = __webpack_public_path__ + "img/box_default.935c9973.png";